import React from "react";
import { useHistory } from "react-router-dom";

import { PasswordController } from "./Password/Password.controller";
import { ForgotPasswordScreen } from "./ForgotPassword.screen";

export const ForgotPasswordController: React.FC = () => {
  const history = useHistory();

  const exitJourney = () => {
    history.replace({
      pathname: "/login",
    });
  };

  return (
    <ForgotPasswordScreen exitJourney={exitJourney}>
      <PasswordController />
    </ForgotPasswordScreen>
  );
};
